import { AnalyticsApi } from '../../generated/api';
import configuration from './configuration';

export default new AnalyticsApi(configuration);
